export const dateObject:any = {
    months:{
      1:"January",
      2:"February",
      3:"March",
      4:"April",
      5:"May",
      6:"June",
      7:"July",
      8:"August",
      9:"September",
      10:"October",
      11:"November",
      12:"December"
    },
    days:{
      1:"st",
      2:"nd",
      3:"rd"
    }
  }

    //  type is 1 if it's month only
    //  type is 2 if it's year only
export const convertTimetoString =(arg:any,time:number)=>{
    let d:Date;
    if(typeof arg === 'string')d = new Date(arg);
    else if(arg == null) d = new Date();
    else d = arg;

    let day = d.getDate();
    let month = d.getMonth() +1;
    let year = d.getFullYear();
    let dayString:any = "th";
    let hour = d.getHours();
    let min = d.getMinutes() > 10 ? d.getMinutes() : `${d.getMinutes()}0`;
    let timeString = hour >= 12 ? "pm" : "am";

    if(day <= 9){
        dayString = dateObject.days[day] ? dateObject.days[day] : 'th';
    }
    else{
        if(day >= 20){
            let tempDay = day%10;
            dayString = dateObject.days[tempDay]?dateObject.days[tempDay]:'th';
        }
    }
    return time == 0?`${day}${dayString} ${dateObject.months[month]}, ${year}`:
    time == 1 ?`${day}${dayString} ${dateObject.months[month]}, ${year} | ${hour}:${min}${timeString}`:
    time == 2 ? `${dateObject.months[month]}, ${year}` :
    time == 3 ? ` ${year}` :
    `${hour}:${min}${timeString}`
    
}

export const stripDateString = (arg:any)=>{
    let day = arg.split(' ')[0].slice(0,-2);
    let month = arg.split(' ')[1].slice(0,3);
    let year = arg.split(',')[1];
    return `${day} ${month} ${year}`;
}